import type { BaselineCapacityTimeslotType } from '@/types/CM/updateCapacity'

export function sortTimeslotsInAscendingOrder (timeslots: BaselineCapacityTimeslotType[]): BaselineCapacityTimeslotType[] {
  return timeslots.sort((a, b) => {
    // Compare startTimes using localeCompare
    const startTimeComparison = a.startTime.localeCompare(b.startTime)
    if (startTimeComparison !== 0) return startTimeComparison

    // Compare endTimes using localeCompare
    return a.endTime.localeCompare(b.endTime)
  })
}
